<template>
  <div class="section">
    <div style="height: 100%;display: flex;flex-direction: column;">
      <div style="display: flex;justify-content: flex-end;margin-bottom: 5px">
        <div v-if="isEdit">
          <el-button type="primary" @click="save">{{ $t('SystemMaintenance.Save') }}</el-button>
          <el-button type="danger" @click="cancel">{{ $t('SystemMaintenance.Cancel') }}</el-button>
          <el-button no="7" type="primary" @click="add">{{ $t('CargoMsg.Cargo_Add') }}</el-button>
          <el-button no="8" type="danger" @click="del">{{ $t('SeaExport.Delete') }}</el-button>
        </div>
        <div v-else>
          <el-button type="primary" :disabled="assemblyPlanInfoIsEdit || !editable" @click="edit">{{ $t('SystemMaintenance.Edit') }}</el-button>
        </div>
      </div>
      <cargo-ag-grid
        no="9"
        config-module="150014"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
        style="height: 100%;"
        @gridReady="params=>{gridApi=params.api}"
      />
    </div>
  </div>
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor/index'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor/index'
import {
  CURRENCY_RMB,
  FEE_STANDARDS,
  FEE_STANDARDS_WEIGHT,
  UNIT_PRICE,
  UNITS
} from '@/class/cargo/model/parameters/SystemConstants'
import { deepClone } from '@/utils'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { saveAssemblyPlanCost } from '@/api/booking/assemblyPlan'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'AssemblyPlanCost',
  props: {
    form: { type: Object, default: () => {} },
    editable: { type: Boolean, default: false },
    assemblyPlanInfoIsEdit: { type: Boolean, default: false }
  },
  data() {
    return {
      delAssemblyPlanCostKeys: [],
      gridOptions: {
        rowSelection: 'multiple',
        singleClickEdit: true,
        suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
        suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        context: {
          componentParent: this
        },
        frameworkComponents: {
          CargoAgGridCommonInputEditor,
          CargoAgGridAdvanceSelectEditor
        }
      },
      columnDefs: [
        {
          headerName: '', width: 55, checkboxSelection: true,
          pinned: 'left',
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SequenceNumber'),
          field: 'serialNumber',
          cellEditor: 'CargoAgGridCommonInputEditor',
          width: 100
        }, {
          headerName: this.$t('SeaExport.ChargeItem'),
          field: 'chargeItemId',
          editable: () => this.isEdit,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              selectType: TYPE_NAMES.basic_data_ChargeItem,
              methodParams: { active: true },
              filterable: true,
              tagValue: 'itemId',
              tagName: 'zhName',
              filterTagNames: ['chargecode', 'enName', 'zhName', 'cnShortName', 'scaleCode', 'languageName'],
              filterType: 'global'
            }
          },
          width: 100,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_PayingParty'), field: 'paymentTarget', width: 180,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          },
          editable: () => this.isEdit,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              selectType: TYPE_NAMES.basic_data_Company,
              tagValue: 'cmpIdx',
              tagName: 'chineseName',
              methodParams: { active: true, airCmp: true, bookingAgent: true },
              filterable: true
            }
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Amount'),
          colId: 'amount',
          field: 'amount',
          initialWidth: 180,
          valueFormatter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return this.$numeral(params.value).format('0.00')
          },
          editable: () => this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            }
          }
        }, {
          headerName: this.$t('Insurance.Charges'),
          field: 'feeStandards',
          editable: () => this.isEdit,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              staticOptions: FEE_STANDARDS,
              tagName: this.$store.getters.isZh ? 'chineseName' : 'englishName',
              tagValue: 'code'
            }
          },
          valueFormatter: params => {
            return ColumnUtils.showTypeLabelFunc(params.value, SystemConstants.FEE_STANDARDS)
          },
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_UnitPrice_TotalPrice'),
          field: 'unit',
          editable: () => this.isEdit,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              staticOptions: UNITS,
              tagName: this.$store.getters.isZh ? 'chineseName' : 'englishName',
              tagValue: 'code'
            }
          },
          valueFormatter: params => {
            return ColumnUtils.showTypeLabelFunc(params.value, SystemConstants.UNITS)
          },
          width: 100
        },
        {
          headerName: this.$t('FinanceManage.charge_currency'),
          colId: 'currency',
          field: 'currency',
          initialWidth: 180,
          editable: () => this.isEdit,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              selectType: TYPE_NAMES.basic_data_Currency,
              filterable: true,
              tagValue: 'code',
              tagName: 'code',
              filterTagNames: ['code']
            }
          }
        }
      ],
      rowData: [],
      gridApi: null,
      isEdit: false
    }
  },
  methods: {
    init() {
      this.rowData = this.form.assemblyPlanCosts || []
    },
    edit() {
      this.rowData = deepClone(this.form.assemblyPlanCosts)
      this.isEdit = true
      this.$emit('isEdit', this.isEdit)
    },
    cancel() {
      this.rowData = this.form.assemblyPlanCosts || []
      this.isEdit = false
      this.$emit('isEdit', this.isEdit)
    },
    save() {
      if (!this.check()) {
        return
      }
      const params = {
        assemblyPlanUuid: this.form.uuid,
        assemblyPlanCosts: this.rowData,
        delAssemblyPlanCostKeys: this.delAssemblyPlanCostKeys
      }
      this.loading = getLoading4Cxt()
      saveAssemblyPlanCost(params).then(res => {
        this.form.assemblyPlanCosts = res.data
        this.rowData = this.form.assemblyPlanCosts
        this.isEdit = false
        this.$emit('isEdit', this.isEdit)
        this.$message.success(this.$t('Message.SaveSuccessfully'))
      }).finally(() => {
        this.loading.close()
      })
    },
    add() {
      const length = this.rowData.length + 1
      const data = {
        serialNumber: length,
        assemblyPlanUuid: this.form.uuid,
        chargeItemId: 0,
        paymentTarget: 0,
        feeStandards: FEE_STANDARDS_WEIGHT.code,
        amount: 0,
        unit: UNIT_PRICE.code,
        currency: CURRENCY_RMB.code
      }
      this.rowData.push(data)
    },
    del() {
      const rows = this.gridOptions.api.getSelectedRows()
      if (!rows || rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      if (this.rowData) {
        for (let i = this.rowData.length - 1; i >= 0; --i) {
          const row = this.rowData[i]
          if (rows.includes(row)) {
            if (row.uuid) {
              this.delAssemblyPlanCostKeys.push(row.uuid)
            }
            this.rowData.splice(i, 1)
          }
        }
      }
      const tempRowData = this.rowData
      this.rowData = []
      this.$nextTick(() => {
        // 重置序号
        for (let i = 0; i < tempRowData.length; i++) {
          const data = tempRowData[i]
          data.serialNumber = i + 1
        }
        this.rowData = tempRowData
        this.gridOptions.api.refreshCells({ force: true })
        this.gridOptions.api.clearFocusedCell()
      })
    },
    // 保存前校验
    check() {
      if (this.voyageCosts && this.voyageCosts.length > 0) {
        for (const voyageCost of this.voyageCosts) {
          if (!voyageCost.chargeItemId) {
            this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('SeaExport.ChargeItem'))
            return false
          }
          if (!voyageCost.paymentTarget) {
            this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_PayingParty'))
            return false
          }
        }
      }
      return true
    }
  }
}
</script>

<style scoped>

</style>
